// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning[data-v-61be6790]{color:#daa520}.letrapreg[data-v-61be6790]{color:#000;font-size:20px}", ""]);
// Exports
module.exports = exports;
